import * as _ from 'lodash';
import * as React from 'react'

interface IButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  color?: 'white' | 'danger' | 'link' | 'link-hc' | 'link-lc' | 'primary'
  large?: boolean
  active?: boolean
  disabled?: boolean
  block?: boolean
  showRefreshSpinner?: boolean
  small?: boolean
}

const addClassIfTrue = (classNames: string[], bool: boolean | undefined, className: string) => {
  if (bool) {
    classNames.push(className)
  }
}

export class Button extends React.Component<IButtonProps, {}> {
  getBtnClasses() {
    const color = this.props.color || 'white'
    const classes = ['btn', `btn-${color}`]
    const { active, large, disabled, block, showRefreshSpinner, small } = this.props

    if (typeof this.props.className === 'string') {
      classes.push(this.props.className)
    }

    addClassIfTrue(classes, active, 'active')
    addClassIfTrue(classes, large, 'btn-large')
    addClassIfTrue(classes, disabled, 'disabled')
    addClassIfTrue(classes, block, 'btn-block')
    addClassIfTrue(classes, showRefreshSpinner, 'spin-icon')
    addClassIfTrue(classes, small, 'btn-sm')

    return classes.join(' ')
  }

  render() {
    const props = _.clone(this.props) as IButtonProps
    delete props.block
    delete props.small
    delete props.className
    delete props.large
    delete props.active
    delete props.color
    delete props.showRefreshSpinner

    return (
      <button className={this.getBtnClasses()} {...props}>
        {this.props.children}
      </button>
    )
  }
}
